<template>
	<div>
		<input class="el-input__inner margin-bottom-10" v-model="keyword" placeholder="查询">
		<!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
		<div class="checkbox-group-box" :style="{height:checkboxgroupHeight + 'px'}">
			<el-checkbox-group v-model="checkedOptions" @change="handlecheckedOptionsChange">
				<el-checkbox style="margin-top:8px;" v-for="(item,index) in searchedItems " :label="item.uuid" :key="index">{{item.name}}</el-checkbox>
			</el-checkbox-group>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataSource: {
				type: Array,
				default: null
			},
			checkedItems: {
				type: Array,
				default: () => []
			},
			checkboxgroupHeight: {
				type: Number
			}
		},
		data() {
			return {
				checkAll: false,
				checkedOptions: this.checkedItems,
				checkedArr: [],
				isIndeterminate: true,
				keyword: '', //搜索关键字
			};
		},
		watch: {
			checkedItems(newVal, oldVal) {
				this.checkedOptions = newVal;
			},
		},
		mounted() {
			let newCheckedOptions = this.getCheckedItems(this.checkedOptions);
			this.checkedArr = newCheckedOptions
		},
		computed: {
			searchedItems: function() {
				var _keyword = this.keyword;
				if (_keyword) {
					var reg = new RegExp(_keyword, 'ig')
					return this.dataSource.filter(function(e) {
						return Object.keys(e).some(function(key) {
							return e[key].match(reg);
						})

					})
				};
				return this.dataSource;
			},
		},
		methods: {
			getCheckedItems(value) {
				let newCheckedOptions = [];
				this.dataSource.forEach((obj, i) => {
					value.forEach((uuid, j) => {
						if (obj.uuid == uuid) {
							newCheckedOptions.push({
								uuid: uuid,
								name: obj.name
							})
						}
					})
				})
				return newCheckedOptions;

			},
			handlecheckedOptionsChange(value) {
				let newCheckedOptions = this.getCheckedItems(value);
				// this.checkedArr = newCheckedOptions
				let data = {
					checkedOptions: newCheckedOptions
				}
				this.$emit('onchecked', data);
			}
		},
	};
</script>

<style>
	.checkbox-group-box {
		margin: 0;
		height: 263px;
		overflow-y: auto;
	}

	.el-input__inner:hover {
		border-color: #C0C4CC;
	}
    .margin-bottom-10{
		margin-bottom:10px;
    }
	.el-input__inner {
		-webkit-appearance: none;
		background-color: #FFF;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 40px;
		line-height: 40px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		width: 100%;
	}
</style>
